// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contact-content[data-v-0ea9e695]  h3{margin-bottom:1rem}.hyphens[data-v-0ea9e695]{-webkit-hyphens:auto;-ms-hyphens:auto;hyphens:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
